/* unplugin-vue-components disabled */import script from "./Tm-dialog.vue?vue&type=script&setup=true&lang=js"
export * from "./Tm-dialog.vue?vue&type=script&setup=true&lang=js"

import "./Tm-dialog.vue?vue&type=style&index=0&id=770f8e96&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-770f8e96"]])

export default __exports__